import * as React from 'react';

export const LocationBold = props => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2167 11.311C8.90091 11.311 7.83091 10.241 7.83091 8.92516C7.83091 7.60933 8.90091 6.53933 10.2167 6.53933C11.5326 6.53933 12.6034 7.60933 12.6034 8.92516C12.6034 10.241 11.5326 11.311 10.2167 11.311ZM10.2084 2.0835C6.53258 2.0835 3.54175 5.111 3.54175 8.83266C3.54175 13.3393 7.42008 17.9168 10.2084 17.9168C12.9959 17.9168 16.8751 13.3393 16.8751 8.83266C16.8751 5.111 13.8842 2.0835 10.2084 2.0835Z"
      fill="#64748B"
    />
  </svg>
);
